import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
//import Grid from '@material-ui/core/Grid';
import { getGlobalClasses } from '../../themes';

import AuthUserContainer from '../../containers/AuthUser';
import Note from '../../components/Note';
import { post } from '../../modules/utility';
import ClockInOutSuccessfulDialog from '../../components/dialogs/ClockInOutSuccessfulDialog';
import ShortShiftConfirmationDialog from '../../components/dialogs/ShortShiftConfirmationDialog';
import DurationCountdown from '../../components/DurationCountdown';

import TimeClockIcon from '../../images/icons/timeClock.svg';
import Button from '@material-ui/core/Button';
import GreenChecked from '../../images/icons/greenChecked.svg';
import WarningIconSvg from '../../images/icons/warningIcon.svg';
import OrangeRightArrow from '../../images/icons/orangeRightArrow.svg';
import Cookies from 'universal-cookie';
import printJS from 'print-js';
import { CircularProgress, Grid } from '@material-ui/core';
import FormSelect from '../form/FormSelect';
import FormComponent from '../FormComponent';
import FormText from '../form/FormText';
import FormTextArea from '../form/FormTextArea';

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		contentTitle: {
			display: 'flex',
			alignItems: 'center',
			fontSize: 24,
			borderBottom: '1px solid #ddd',
			paddingBottom: 15,
			marginBottom: 15,
		},
		timeClockIcon: {
			display: 'inline-block',
			width: 30,
			height: 30,
			backgroundImage: `url('${TimeClockIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 7,
			marginLeft: 0,
		},
		runningSearch: {
			paddingLeft: 5,
			display: 'inline',
			alignItems: 'center',
			fontSize: 18,
			color: '#666',
		},
		greenCheckedIcon: {
			display: 'inline-block',
			width: 30,
			height: 30,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 12,
			marginLeft: 0,
			marginTop: 5,
		},
		smallWarningIcon: {
			display: 'inline-block',
			width: 40,
			height: 40,
			backgroundImage: `url('${WarningIconSvg}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 10,
			marginLeft: 0,
			marginTop: 0,
		},
		orangeRightArrow: {
			display: 'inline-block',
			width: 30,
			height: 30,
			backgroundImage: `url('${OrangeRightArrow}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight: 7,
			marginLeft: 0,
		},

		clockButton: {
			padding: `20px 65px`,
			margin: 10,
			fontSize: 20,
			fontWeight: 800,
		},
		timeClockRule: {
			display: 'flex',
			fontSize: 18,
		},
		currentStatusTitle: {
			textTransform: 'uppercase',
			fontSize: 20,
			letterSpacing: 1,
			color: '#333',
			marginTop: 5,
			marginLeft: 5,
			marginBottom: 10,
		},
		currentStatusDetails: {
			lineHeight: 1.5,
			marginBottom: 20,
		},
		statusValue: {
			fontWeight: 600,
			marginLeft: 5,
		},
		durationToWaitFor10Hours: {
			fontSize: '120%',
			fontWeight: 700,
		},
		infoSection: {
			display: 'flex',
			flexDirection: 'row',
			fontSize: 18,
			marginBottom: 30,
		},
		hasBrowserAuthCode: {
			fontSize: '120%',
			padding: 20,
			border: '1px solid #ddd',
			backgroundColor: '#f7f7f7',
			borderRadius: 3,
		},
	};
};

const earlyReasonValue = {
	operational: 'operational',
	tmApproved: 'tmApproved',
	dispatchApproved: 'dispatchApproved',
	other: 'other',
};

class ClockInAndOut extends FormComponent {
	constructor(props) {
		super(props);
		this.state = {
			order: 'desc',
			orderBy: 'clockInDateTime',
			lastPunchInfoResults: undefined,
			showClockInSuccessful: false,
			showClockOutSuccessful: false,
			recentTimeClockShifts: undefined,
			showShortShiftDialog: false,

			isPrintingCe: false,
		};
	}

	componentDidMount() {
		this.getShiftAnalysis({ callback: _.noop });
	}

	getShiftAnalysis = ({ callback }) => {
		const { showErrors } = this.props;
		post({
			method: 'timeClockShift.user.getShiftAnalysis',
			params: {},
			callback: (err, r) => {
				if (err) {
					showErrors(err);
					return callback(err);
				}

				const timeClockAnalysisResult = _.get(r, 'timeClockAnalysisResults.0', {});
				this.setState({
					timeClockAnalysisResult,
				});
				callback(null, { timeClockAnalysisResult });
			},
		});
	};

	formatDurationToMinutes = (d) => {
		return moment.duration(d).format('d [days], h [hours], m [minutes]');
	};

	handleCountdownDone = () => {};

	render() {
		const { classes, showPrintDeliveryTickets } = this.props;
		const { timeClockAnalysisResult } = this.state;

		const cookies = new Cookies();
		const hasBrowserAuthCode = cookies.get('browserAuthCode');
		const hasTimeClockLocationId = cookies.get('timeClockLocationId');
		const hasAllAuth = hasBrowserAuthCode && hasTimeClockLocationId;

		if (_.isUndefined(timeClockAnalysisResult)) {
			return <div className={classes.globalFetching}>Fetching time clock info...</div>;
		}

		const {
			canClockIn,
			canClockOut,
			isCurrentlyClockedIn,
			isCurrentlyClockedOut,
			dateTimeOfLastClockIn,
			dateTimeOfLastClockOut,
			isLessThan10HoursFromLastShift,

			//lastShift, currentShift,

			hasWorkedOver80HoursSinceLastReset,
			last34HourResetDateTime,
			secondsWorkedSinceLast34HourReset,

			doNotShow34HourRule,
			hasOpenTickets,
			canNotClockInReason,
			shiftWarningText,
			requireEarlyClockInReason,
			requireEarlyClockInReasonWarning,
		} = timeClockAnalysisResult;
		const { earlyClockInReason, dispatcherName, otherReason } = this.state;

		let isClockInDisabled = !canClockIn;
		let isClockOutDisabled = !canClockOut;
		let clockedInDisabledReason = '';

		// They can only clock in if they require a reason
		// if they supplied the reason
		if (requireEarlyClockInReason) {
			isClockInDisabled = true;
			clockedInDisabledReason = 'Reason required';
			// Lets see if we have everything we need
			if (earlyClockInReason) {
				if (earlyClockInReason === earlyReasonValue.other) {
					if (otherReason) {
						isClockInDisabled = false;
					} else {
						clockedInDisabledReason = 'Detailed reason required';
						isClockInDisabled = true;
					}
				} else if (earlyClockInReason === earlyReasonValue.dispatchApproved) {
					if (dispatcherName) {
						isClockInDisabled = false;
					} else {
						clockedInDisabledReason = 'Dispatcher name required';
						isClockInDisabled = true;
					}
				} else {
					isClockInDisabled = false;
				}
			}
			if (isClockInDisabled === false) {
				clockedInDisabledReason = '';
			}
		}

		if (this.state.clockButtonsDisabled) {
			isClockInDisabled = true;
			isClockOutDisabled = true;
		}

		let durationSinceLastShift = moment.duration(moment().diff(moment(dateTimeOfLastClockOut)));
		let durationClockedIn = moment.duration(moment().diff(moment(dateTimeOfLastClockIn)));
		if (durationClockedIn === -1) {
			durationClockedIn = 0;
		}

		if (durationSinceLastShift === -1) {
			durationSinceLastShift = 0;
		}

		let tenHoursAfterClockOut;
		if (isLessThan10HoursFromLastShift) {
			const clockOutMoment = moment(dateTimeOfLastClockOut);
			tenHoursAfterClockOut = moment(clockOutMoment).add(10, 'hours');
		}

		let hoursSinceLast34HourReset = '-';
		let thirtyFourHoursAfterClockOut;
		if (secondsWorkedSinceLast34HourReset) {
			hoursSinceLast34HourReset = moment
				.duration(secondsWorkedSinceLast34HourReset, 'seconds')
				.format('h [hrs]', 2);
			const clockOutMoment = moment(dateTimeOfLastClockOut);
			thirtyFourHoursAfterClockOut = moment(clockOutMoment).add(34, 'hours');
		}

		return (
			<Fragment>
				<Paper className={classes.globalMainPaper}>
					<div className={classes.contentTitle}>
						<div className={classes.timeClockIcon} />
						<div>Time Clock</div>
					</div>

					{isCurrentlyClockedOut && (
						<div>
							<div className={classes.infoSection}>
								{!isLessThan10HoursFromLastShift && <div className={classes.greenCheckedIcon} />}
								{isLessThan10HoursFromLastShift && <div className={classes.smallWarningIcon} />}
								<div>
									<div>
										<span>Time since last shift : </span>
										<span>{this.formatDurationToMinutes(durationSinceLastShift)}</span>
									</div>
									<div>
										<span>Last shift end date & time : </span>
										<span className={classes.statusValue}>
											{moment(dateTimeOfLastClockOut).format('M/D h:mm a')}
										</span>
									</div>

									{isLessThan10HoursFromLastShift && (
										<Note>
											Time to wait until you can clock in to clear 10 hours off shift requirement.
											<div className={classes.durationToWaitFor10Hours}>
												<DurationCountdown
													startMoment={tenHoursAfterClockOut}
													handleCountdownDone={this.handleCountdownDone}
												/>
											</div>
										</Note>
									)}
								</div>
							</div>

							{!doNotShow34HourRule && (
								<div className={classes.infoSection}>
									{!hasWorkedOver80HoursSinceLastReset && (
										<div className={classes.greenCheckedIcon} />
									)}
									{hasWorkedOver80HoursSinceLastReset && (
										<div className={classes.smallWarningIcon} />
									)}
									<div>
										<div>
											<span>Hours worked since last 34 hour reset : </span>
											<span className={classes.statusValue}>{hoursSinceLast34HourReset}</span>
										</div>
										<div>
											<span>Last 34 hour reset date and time : </span>
											<span className={classes.statusValue}>
												{moment(last34HourResetDateTime).format('M/D h:mm a')}
											</span>
										</div>

										{hasWorkedOver80HoursSinceLastReset && (
											<Note>
												Time to wait until you can clock in to clear 34 hours reset requirement.
												<div className={classes.durationToWaitFor10Hours}>
													<DurationCountdown
														startMoment={thirtyFourHoursAfterClockOut}
														handleCountdownDone={this.handleCountdownDone}
													/>
												</div>
											</Note>
										)}
									</div>
								</div>
							)}
						</div>
					)}

					{hasOpenTickets && (
						<div className={classes.infoSection}>
							<div>
								<Note>
									<div className={classes.smallWarningIcon} />
									You have an open incident report. Please fill out this report before you clock
									out.
								</Note>
							</div>
						</div>
					)}

					{canNotClockInReason && (
						<div className={classes.infoSection}>
							<div>
								<div className={classes.smallWarningIcon} />
								<Note>{canNotClockInReason}</Note>
							</div>
						</div>
					)}

					{shiftWarningText && (
						<div className={classes.infoSection}>
							<div>
								<Note>
									<div style={{ display: 'flex', lineHeight: 1.3 }}>
										<div className={classes.smallWarningIcon} />
										<span>{shiftWarningText}</span>
									</div>
								</Note>
							</div>
						</div>
					)}

					{requireEarlyClockInReason && (
						<div>
							<div className={classes.infoSection}>
								<div>
									<Note>
										<div style={{ display: 'flex', lineHeight: 1.3 }}>
											<div className={classes.smallWarningIcon} />
											<span>{requireEarlyClockInReasonWarning}</span>
										</div>
									</Note>
								</div>
							</div>

							<Note>
								<div style={{ fontSize: '100%', fontWeight: 'bold' }}>
									Reason for early clock-in
								</div>

								<Grid container spacing={2} style={{ marginTop: 0, marginBottom: 0 }}>
									<FormSelect
										{...this.setForm('earlyClockInReason', 'Select early clock-in reason')}
										options={[
											{ display: 'Safety Meeting', value: earlyReasonValue.operational },
											{ display: 'TM Approved', value: earlyReasonValue.tmApproved },
											{
												display: 'Dispatch Approved',
												value: earlyReasonValue.dispatchApproved,
											},
											{ display: 'Other', value: earlyReasonValue.other },
										]}
									/>

									{earlyClockInReason === earlyReasonValue.dispatchApproved && (
										<FormText
											{...this.setForm(`dispatcherName`, 'Name of dispatcher that approved')}
											variant="outlined"
										/>
									)}
									{earlyClockInReason === earlyReasonValue.other && (
										<FormTextArea
											{...this.setForm(`otherReason`, 'Detailed reason for early clock in')}
											variant="outlined"
										/>
									)}
								</Grid>
							</Note>
						</div>
					)}

					{isCurrentlyClockedIn && (
						<div>
							<div className={classes.timeClockRule}>
								<div className={classes.greenCheckedIcon} />
								<div>
									<div className={classes.currentStatusTitle}>Currently Clocked In</div>
									<div className={classes.currentStatusDetails}>
										<div>
											<span>- Clocked in for :</span>
											<span className={classes.statusValue}>
												{this.formatDurationToMinutes(durationClockedIn)}
											</span>
										</div>
										<div>
											<span>- Clocked in at :</span>
											<span className={classes.statusValue}>
												{moment(dateTimeOfLastClockIn).format('M/D h:mm a')}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div className={classes.timeClockRule}></div>
						</div>
					)}

					{hasAllAuth && (
						<div style={{ alignItems: 'flex-start', display: 'flex' }}>
							<ClockButton
								label={'Clock In'}
								classes={classes}
								onClick={this.clockIn}
								disabled={isClockInDisabled}
								disabledReason={clockedInDisabledReason}
							/>
							<ClockButton
								label={'Clock Out'}
								classes={classes}
								onClick={this.clockOut}
								disabled={isClockOutDisabled}
							/>
							{showPrintDeliveryTickets && (
								<div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
									<Button
										variant="contained"
										color="primary"
										aria-label="Print CE Delivery Tickets"
										size="large"
										className={classes.clockButton}
										disabled={isClockOutDisabled || this.state.isPrintingCe}
										onClick={this.printCeDeliveryTickets}
									>
										Print CE Delivery Tickets
									</Button>
									{this.state.isPrintingCe && (
										<div className={classes.runningSearch}>
											<CircularProgress size="1rem" />
											<span style={{ paddingLeft: 5, paddingTop: 5 }}>
												Generating tickets, print dialog will show up shortly
											</span>
										</div>
									)}
								</div>
							)}
						</div>
					)}
					{!hasAllAuth && (
						<div className={classes.hasBrowserAuthCode}>
							You can not Clock in and Clock out from this browser because it has not been
							authorized and/or a location has not been set. Please contact your admin.
						</div>
					)}
				</Paper>

				<ClockInOutSuccessfulDialog
					open={this.state.showClockInSuccessful}
					onClose={this.handleClockInOutClose}
					isClockIn={true}
					showPrintDeliveryTickets={showPrintDeliveryTickets}
				/>

				<ClockInOutSuccessfulDialog
					open={this.state.showClockOutSuccessful}
					onClose={this.handleClockInOutClose}
					timeClockAnalysisResult={timeClockAnalysisResult}
					isClockOut={true}
				/>
				<ShortShiftConfirmationDialog
					open={this.state.showShortShiftDialog}
					onClose={this.handleCloseShortShiftDialog}
					onConfirm={this.onConfirmShortShiftClockOut}
				/>
			</Fragment>
		);
	}

	handleSort = (orderBy) => {
		let order = 'desc';
		if (this.state.orderBy === orderBy && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order: order, orderBy: orderBy });
	};

	clockIn = () => {
		const { showErrors } = this.props;
		this.setState({ clockButtonsDisabled: true });

		const { earlyClockInReason, dispatcherName, otherReason, timeClockAnalysisResult } = this.state;
		const { closestShiftStartDateTime } = timeClockAnalysisResult;

		const params = {};
		const cookies = new Cookies();
		params.browserAuthCode = cookies.get('browserAuthCode');
		params.timeClockLocationId = parseInt(cookies.get('timeClockLocationId'), 10);
		params.userAgent = navigator.userAgent;

		params.earlyClockInReason = earlyClockInReason || undefined;
		params.dispatcherName = dispatcherName || undefined;
		params.otherReason = otherReason || undefined;
		params.closestShiftStartDateTime = closestShiftStartDateTime || undefined;

		post({
			method: 'timeClockShift.user.clockIn',
			params,
			callback: (err) => {
				if (err) {
					showErrors(err);
					return;
				}

				this.getShiftAnalysis({ callback: _.noop });
				this.setState({
					clockButtonsDisabled: false,
					showClockInSuccessful: true,
				});
			},
		});
	};

	onConfirmShortShiftClockOut = ({ reason }) => {
		this.submitClockOut(reason);
	};

	clockOut = () => {
		const { showErrors } = this.props;
		const { timeClockAnalysisResult } = this.state;
		const { currentShift } = timeClockAnalysisResult;

		if (!_.isObject(currentShift)) {
			showErrors(`Could not find current shift so can't logout. Please refresh try again`);
			return;
		}

		// Check if they try to double punch
		const { dateTimeOfLastClockIn } = timeClockAnalysisResult;
		let minutesClockedIn = moment().diff(moment(dateTimeOfLastClockIn), 'minutes');
		if (minutesClockedIn <= 5) {
			this.setState({
				showShortShiftDialog: true,
			});
			return;
		}
		this.submitClockOut();
	};

	printCeDeliveryTickets = () => {
		const { showErrors, userId } = this.props;
		this.setState({ isPrintingCe: true });
		post({
			method: 'ce.getDeliveryTicketPdf',
			params: {
				userId,
			},
			callback: (err, r) => {
				this.setState({ isPrintingCe: false });
				if (err) {
					return showErrors(err);
				}

				if (!r.resource) {
					return showErrors('Missing resource');
				}
				const url = r.resource.url;
				printJS({ printable: url, type: 'pdf' });
			},
		});
	};

	submitClockOut = (note) => {
		const { showErrors } = this.props;
		const { timeClockAnalysisResult } = this.state;
		const { currentShift } = timeClockAnalysisResult;
		const { timeClockShiftId } = currentShift;
		this.setState({ clockButtonsDisabled: true });

		const params = { timeClockShiftId };
		const cookies = new Cookies();
		params.browserAuthCode = cookies.get('browserAuthCode');
		params.timeClockLocationId = parseInt(cookies.get('timeClockLocationId'), 10);
		params.userAgent = navigator.userAgent;

		if (note) {
			params.note = note;
		}

		post({
			method: 'timeClockShift.user.clockOut',
			params,
			callback: (err) => {
				if (err) {
					showErrors(err);
					return;
				}

				this.getShiftAnalysis({
					callback: (err) => {
						if (err) {
							return;
						}
						this.setState({
							clockButtonsDisabled: false,
							showClockOutSuccessful: true,
						});
					},
				});
			},
		});
	};

	handleClockInOutClose = () => {
		const wasClockIn = this.state.showClockInSuccessful;
		const { onClockInSuccessfulClose } = this.props;

		this.setState({
			showClockInSuccessful: false,
			showClockOutSuccessful: false,
		});

		if (wasClockIn && onClockInSuccessfulClose) {
			onClockInSuccessfulClose();
		}
	};

	handleCloseShortShiftDialog = () => {
		this.setState({
			showShortShiftDialog: false,
		});
	};
}

function ClockButton(props) {
	const { label, disabled, disabledReason, onClick, classes } = props;
	return (
		<div style={{ display: 'inline-block' }}>
			<Button
				variant="contained"
				color="primary"
				aria-label="Add"
				size="large"
				className={classes.clockButton}
				disabled={disabled}
				onClick={onClick}
			>
				{label}
			</Button>
			{disabledReason && (
				<div style={{ fontSize: '90%', color: '#777', fontStyle: 'italic', textAlign: 'center' }}>
					{disabledReason}
				</div>
			)}
		</div>
	);
}

ClockInAndOut.propTypes = {
	authUser: PropTypes.object,
	userId: PropTypes.number,
	onClockInSuccessfulClose: PropTypes.func,
};

export default _.flow([withStyles(styles), AuthUserContainer])(ClockInAndOut);
